import { AmmFavoriteBackend, AmmPrice, Image, Product, Store, VariantValue } from "./catalog.model";

export class Favorite {
  merchCode?: string;
  action?: string;

  title?: string;
  label?: string;
  id?: number;
  code?: string;
  mainImage?: Image;
  thumbnail?: Image;
  favorite?: boolean;
  isMainVariant?: boolean;
  inventory?: number;
  curPrice?: AmmPrice;
  store?: Store;
  variantFamily?:string;
  status?: string;
  variantMinPrice?: AmmPrice;
  
  variantMaxPrice?: AmmPrice;
  variantValues?: VariantValue[];

  variantsCount?: number;
  variantMerchs?: Product[];

  static formatData(x: AmmFavoriteBackend): Favorite {
    return {
      merchCode: x.merchCode,
      action: 'ADD',
      id: x.merchandise?.id, 
      label: x.label,
      title: x.merchandise?.title || x.merchFamily?.title,
      code: x.merchCode,
      status: x.merchandise?.status || x.merchFamily?.status,
      variantFamily: x.merchCode,
      mainImage: x.merchandise?.mainImage || x.merchFamily?.mainImage,
      favorite: true,
      isMainVariant: x.merchandise === undefined,
      inventory: x.merchandise?.inventory,
      curPrice: x.merchandise?.curPrice,
      store: x.merchandise?.store || x.merchFamily?.store,
      variantMinPrice: x.merchFamily?.variantMinPrice
    }
  }
}

export type FavoriteAction = 'ADD' | 'REMOVE';
